export default class AccountReceiveableActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_ACCOUNTRECEIVEABLE='GET_HELPER_ACCOUNTRECEIVEABLE';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: AccountReceiveableActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: AccountReceiveableActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: AccountReceiveableActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: AccountReceiveableActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: AccountReceiveableActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: AccountReceiveableActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: AccountReceiveableActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: AccountReceiveableActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: AccountReceiveableActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: AccountReceiveableActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: AccountReceiveableActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: AccountReceiveableActions.GET_HELPER_ACCOUNTRECEIVEABLE,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: AccountReceiveableActions.ERROR_SERVER,
      payload: error
    };
  }
}